import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "src/@/components/ui/button";
import RequestFormModal from "./request-form-modal";

// ЦЕЛЕВАЯ КНОПКА САЙТА.
//
// Нажатие открывает короткую анкету, а уже из неё человек уходит в WhatsApp
// с готовым сообщением: кто он, сколько человек, какой тур или услуга,
// даты, маршрут и ссылка на страницу. Раньше кнопка вела в чат сразу, и
// менеджер начинал с расспросов — теперь он получает заявку целиком.
//
// Анкеты две (см. request-form-modal.jsx):
//   basic    — имя и количество человек;
//   transfer — трансфер из аэропорта: откуда, куда, багаж, дата и время.
//
// Пропсы:
//  - subject: название тура или услуги — подставляется в первую фразу
//  - intent: "book" — «хочу забронировать», "ask" — «интересует, расскажите».
//    Первая фраза должна совпадать с подписью кнопки: под «Забронировать»
//    странно читается «подскажите детали»
//  - details: пары [подпись, значение] — даты, маршрут, взнос
//  - extra: готовый блок текста (опции, выбранные калькулятором)
//  - label: подпись кнопки; пусто — общая надпись из переводов
//  - form: какую анкету показать
//  - withIcon: значок мессенджера. Ставим на крупных кнопках, где есть место;
//    в узкой шапке он только съедает ширину
export default function WhatsappCta({
  subject = "",
  details = [],
  extra = "",
  label,
  intent = "ask",
  form = "basic",
  className = "",
  variant = "default",
  size = "lg",
  tabIndex,
  withIcon = false,
}) {
  const { t } = useTranslation();
  const text = label || t("request.trigger");

  const intro = subject
    ? t(intent === "book" ? "request.whatsappBook" : "request.whatsappText", { subject })
    : t("request.whatsappTextGeneric");

  return (
    <RequestFormModal
      variant={form}
      intro={intro}
      details={details}
      extra={extra}
      trigger={
        <Button
          variant={variant}
          size={size}
          className={`gap-2 ${className}`}
          // -1 для кнопки в спрятанной липкой полосе: она уехала за край
          // экрана, но по Tab до неё всё ещё можно было дойти
          tabIndex={tabIndex}
        >
          {withIcon && <MessageCircle aria-hidden="true" className="h-4 w-4" />}
          {text}
        </Button>
      }
    />
  );
}
